import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const NAV_COLLAPSED_WIDTH = 72;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'navCollapsed',
})(({ theme, navCollapsed }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  width: `calc(100% - ${navCollapsed ? NAV_COLLAPSED_WIDTH : NAV_WIDTH + 1}px)`,
  transition: theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  navCollapsed: PropTypes.bool,
  pageTitle: PropTypes.string,
};

export default function Header({ navCollapsed, pageTitle }) {
  return (
    <StyledRoot navCollapsed={navCollapsed}>
      <StyledToolbar>
        {pageTitle && (
          <Typography variant="h4" noWrap sx={{ color: 'text.primary', ml: 1 }}>
            {pageTitle}
          </Typography>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
